import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { takeUntil } from 'rxjs';
import { StudyFile } from 'src/app/models/Study/study-file.model';
import { MediaCategory } from 'src/app/models/media/media-category.model';
import { BaseUnsubscribeComponent } from 'src/app/shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { ViewMode } from 'src/app/shared-new/enums/view-mode.emun';
import { CategoryModalComponent } from '../category-modal/category-modal.component';
import swal from 'sweetalert2';
import Constants from 'src/app/constants.json';
import { MediaGroup } from '../../../../models/media/media-group.model';
import { StudyStatus } from '../../../../shared-new/enums/study-status.enum';

@Component({
  selector: 'app-xray-item',
  templateUrl: './xray-item.component.html',
  styleUrls: ['./xray-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XrayItemComponent
  extends BaseUnsubscribeComponent
  implements OnInit {
  @Input() studyFile: StudyFile = null;
  @Input() mediaCategory: MediaCategory = null;
  @Input() mediaCategoryId: number = null;
  @Input() mediaCategories: MediaCategory[] = [];
  @Input() isDuplicate: boolean = false;
  @Input() isUnknown: boolean = false;
  @Input() isShowUpload: boolean = true;
  @Input() uploadDisabled: boolean = false;
  @Input() viewMode: ViewMode = ViewMode.DRAFT;
  @Input() hideMatchedCategories: boolean = false;
  @Input() viewonly: boolean = false;
  @Input() isEditable: boolean = false;
  @Input() mediaGroups: MediaGroup[];
  StudyStatus = StudyStatus;
  @Output() changeCategoryClicked: EventEmitter<{
    studyFile: StudyFile;
    mediaCategoryId: number;
    replacing?: boolean;
    extra?: boolean;
  }> = new EventEmitter<{ studyFile: StudyFile; mediaCategoryId: number }>();
  @Output() uploadAdditionalClicked: EventEmitter<{
    studyFile: StudyFile;
    isAdditional: boolean;
  }> = new EventEmitter<{ studyFile: StudyFile; isAdditional: boolean }>();
  @Output() deleteStudyFileClicked: EventEmitter<number> =
    new EventEmitter<number>();

  @Output() useImageClicked: EventEmitter<number> = new EventEmitter<number>();
  @Output() uploadFiles: EventEmitter<{
    file: File;
    mediaCategoryId: number;
  }> = new EventEmitter<{ file: File; mediaCategoryId: number }>();

  @Output() updateStatus: EventEmitter<{
    studyFileId: number;
    statusId: number;
    reason: string;
  }> = new EventEmitter<{
    studyFileId: number;
    statusId: number;
    reason: string;
  }>();

  @Output() viewImage: EventEmitter<{
    url: string;
    studyFileId: number;
  }> = new EventEmitter<{
    url: string;
    studyFileId: number;
  }>();

  form: FormGroup = new FormGroup({
    mediaCategoryId: new FormControl(''),
  });
  ViewMode = ViewMode;
  showUpdateCategoryButton: boolean = false;
  matchedCategories: MediaCategory[] = [];
  unmatchedCategories: MediaCategory[] = [];

  constructor(private modalService: NgbModal) {
    super();
  }

  public get isEmptyStudyFile(): boolean {
    if (this.studyFile && this.studyFile?.studyFileId > 0) {
      return false;
    } else {
      return true;
    }
  }

  ngOnInit(): void {
    if (this.mediaCategoryId) {
      this.mediaCategory = this.mediaCategories.find(x => x.id == this.mediaCategoryId);
    }
    if (this.mediaCategory?.id || this.studyFile?.mediaCategoryId) {
      this.form.patchValue({
        mediaCategoryId:
          this.mediaCategory?.id || this.studyFile?.mediaCategoryId,
      });
    }

    this.form.controls['mediaCategoryId'].valueChanges
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((value) => {
        if (!this.isUnknown) {
          console.log('selectedCategory', value);
          console.log('curent category', this.studyFile?.mediaCategoryId);
        }
        this.showUpdateCategoryButton = this.isUnknown
          ? !!value
          : this.studyFile && this.studyFile?.mediaCategoryId
            ? this.studyFile?.mediaCategoryId !== value
            : false;
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    const categories = changes['mediaCategories']?.currentValue;
    if (categories) {
      this.matchedCategories = categories.filter(
        (c: MediaCategory) => c.matched
      );

      this.unmatchedCategories = categories.filter(
        (c: MediaCategory) => !c.matched
      );
      // if (this.unmatchedCategories.length && !this.studyFile?.mediaCategoryId) {
      //   setTimeout(() => {
      //     this.form.patchValue({
      //       mediaCategoryId: this.unmatchedCategories[0].id,
      //     });
      //   }, 100);
      // }
    }
  }

  emitChangeCategoryClicked(
    mediaCategoryId: number,
    replacing: boolean = false,
    extra: boolean = false
  ): void {

    this.changeCategoryClicked.emit({
      studyFile: this.studyFile,
      mediaCategoryId: mediaCategoryId,
      replacing,
      extra
    });
  }

  emitUploadAdditionalClicked(isAdditional: boolean = false): void {
    this.uploadAdditionalClicked.emit({
      studyFile: this.studyFile,
      isAdditional,
    });
  }

  emitDeleteStudyFileClicked(): void {
    this.deleteStudyFileClicked.emit(this.studyFile.studyFileId);
  }

  emitUseImageClicked(): void {
    this.useImageClicked.emit(this.studyFile.studyFileId);
  }

  resetSelectedCategory(): void {
    this.form.patchValue({
      mediaCategoryId: this.studyFile?.mediaCategoryId || '',
    });
  }

  selectFiles(files: File[]): void {
    this.uploadFiles.emit({
      file: files[0],
      mediaCategoryId: this.form.value['mediaCategoryId'],
    });
  }

  emitUpdateStatus(statusId: number, reason: string = ''): void {
    this.updateStatus.emit({
      studyFileId: this.studyFile.studyFileId,
      statusId,
      reason,
    });
  }

  reasonForDenial(): void {
    this.emitUpdateStatus(3);
  }

  emitViewImage(): void {
    if (this.studyFile) {
      this.viewImage.emit({
        url: this.studyFile?.thumbURL,
        studyFileId: this.studyFile.studyFileId,
      });
    }
  }

  openCategoryModal(): void {

    const modalRef = this.modalService.open(CategoryModalComponent, {
      ariaLabelledBy: 'Id',
      centered: true,
      size: 'full-width',
      keyboard: false,
      backdrop: 'static',
    });
    modalRef.componentInstance.mediaCategoriesLeft = this.mediaCategories.filter(x => x.leftOrRight == "Left");
    modalRef.componentInstance.mediaCategoriesRight = this.mediaCategories.filter(x => x.leftOrRight == "Right");
    modalRef.componentInstance.mediaGroups = this.mediaGroups;
    modalRef.componentInstance.studyFile = this.studyFile;

    modalRef.result.then((result) => {
      if (result) {
        this.emitChangeCategoryClicked(
          result.mediaCategoryId,
          result.replacing,
          result.extra
        );
      }
    });
  }
}
